export class UserId {
	public dob: string;
	public contractNumber: string;
	public ssn: string;
	public userType: string;
	public lastName: string;
	public userId: string;
	public email: string;
	public action: string;
	public idType: string;
	public ssnPasteEvent: string;
}
